import { shareTitleSelector } from './shareTitleSelector';
import { IState } from '../store';

export const getShortShareTitleSelector = (state: IState) => {
  return shareTitleSelector(state, true);
};
